import {getCurrentQueryObject} from '../../tools/func';
import {useParams} from 'react-router-dom';
import {setAccessToken} from '../../api';

export default function AutoLogin() {
    const params = useParams()
    setAccessToken(params.access_token, true)
    const {to} = getCurrentQueryObject();
    window.location.href = to || "/"
    return null;
}
